@if (showContainer) {
<div class="upload-documents-container">
  <div class="header-section" [class.view-mode-header]="payload.isViewMode">
    {{payload.title}}
  </div>
  @if (!payload.isViewMode) {
    <div class="cancel-icon">
      <mat-icon class="cross-icon" title="Close Images and Documents Window" (click)="cancel()">cancel</mat-icon>
    </div>
  }
  @if (loader.message) {
    <div class="loader-class" [class.loader-class-overlay]="payload.isViewMode && loader.message"
      [class.loader-class-inline]="payload.isViewMode && loader.isLoading">
      <mat-spinner color="primary"></mat-spinner>
      <div class="loader-message">{{loader.message}}</div>
    </div>
  }
  @if (errorMessage) {
    <div class="error-container">
      <div class="div-error-icon"><mat-icon>error_outline</mat-icon></div>
      <div class="loader-message">{{errorMessage}}</div>
    </div>
  }
  @if (!loader.isLoading && !errorMessage) {
    <div class="category-container" [class.disable-form]="loader.message !== ''">
      @for (category of uploadDocumentsConfiguration; track category.category_id) {
        <div class="documents-container mat-elevation-z2">
          <div class="category-title-area">
            <span class="category-title-name" [class.view-mode-title]="payload.isViewMode">
              {{category.category_name}}
            </span>
          </div>
          <div class="documents-area">
            @for (file of category.uploaded_files; track file.id) {
              <!-- Distribute height evenly based on category's max file count -->
              <div [class]="file.fileType === 'Image' ? 'thumbnail-container' : 'mat-elevation-z2 misc-container'"
                [style.height]="payload.isViewMode ? 'auto' : `${90 / category.max_file_count}%`"
                [style.max-height.%]="payload.isViewMode ? 100 : 30">
                @if (file.fileType === 'Image') {
                  <div #thumbnailWindow class="thumbnail-preview" [id]="file.id" [title]="file.file_name">
                    <mqcs-ui-image [src]="file.file_thumbnail_URL" [alt]="file.file_name" [mode]="'basic'"
                      [width]="'100%'" [height]="'100%'" [skeletonLoader]="file.isLoading">
                    </mqcs-ui-image>
                  </div>
                }
                @else {
                  <div class="other-documents" title="{{file.file_name}}">{{file.file_name}}</div>
                }
                <div class="thumbnail-controls">
                  @if (!payload.isViewMode) {
                    <span>File Size: {{file.file_kb_size}} KB</span>
                  }
                  <div class="thumbnail-action-buttons">
                    @if (file.fileType === 'Image') {
                      <mqcs-ui-button [title]="'Preview image in new tab'"
                        [variant]="'secondary'" [iconType]="'open_in_new'" [iconButtonSize]="'small'"
                        (onClick)="openImageInNewTab(file)">
                      </mqcs-ui-button>
                    }
                    <mqcs-ui-button [title]="`Download ${file.fileType}`" 
                      [variant]="'secondary'" [iconType]="'download'" [iconButtonSize]="'small'" 
                      (onClick)="onDownload(file)">
                    </mqcs-ui-button>
                    @if (!payload.isViewMode) {
                      <mqcs-ui-button [title]="`Delete ${file.fileType}`"
                        [variant]="'danger'" [iconType]="'delete'" [iconButtonSize]="'small'"
                        (onClick)="onDelete(category, file)">
                      </mqcs-ui-button>
                    }
                  </div>
                </div>
              </div>
            }
            @if (category.uploaded_files.length < category.max_file_count && !payload.isViewMode) {
              <div class="dotted-container">
                @if (!loader.message) {
                  <p-fileupload name="file_upload" [customUpload]="true" [showCancelButton]="false"
                    [maxFileSize]="maxUploadFileSize.bytes" mode="basic" [showUploadButton]="false"
                    [accept]="category.category_type" (onSelect)="onFileSelect($event, category)">
                  </p-fileupload>
                }
                <span>Upload more ({{category.max_file_count - category.uploaded_files.length}}
                  {{category.category_type === 'image/*' ? 'images' : 'documents'}} remaining)
                </span>
              </div>
            }
          </div>
          <div class="category-footer-area">
            <span class="category-file-counter" [class.category-file-counter-subtle]="payload.isViewMode">
              {{category.uploaded_files.length}}/{{category.max_file_count}} Files
            </span>
          </div>
        </div>
      }
    </div>
  }
</div>
}